import common from "./common.json";
import lookup from "./lookup.json";
import product from "./product.json";
import errors from "./errors.json";

export default {
  common,
  lookup,
  product,
  errors,
};
